'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgChevronleft, SvgChevronright } from '@common/icon';
import { useState } from 'react';
import { TREND_PAGE_SIZE } from './constants';
import { TrendKeywordPanel } from './TrendKeywordPanel';
import type { TrendKeywordItem } from './useTrendKeywords';
interface TrendKeywordPagerProps {
  keywords: TrendKeywordItem[];
  onSelect: (keyword: string) => void;
}
export const TrendKeywordPager = t0 => {
  const $ = _c(41);
  const {
    keywords,
    onSelect
  } = t0;
  const [pageIndex, setPageIndex] = useState(0);
  let t1;
  if ($[0] !== keywords) {
    t1 = keywords.slice(0, TREND_PAGE_SIZE);
    $[0] = keywords;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const firstPage = t1;
  let t2;
  if ($[2] !== keywords) {
    t2 = keywords.slice(TREND_PAGE_SIZE);
    $[2] = keywords;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const secondPage = t2;
  if (secondPage.length === 0) {
    let t3;
    if ($[4] !== firstPage || $[5] !== onSelect) {
      t3 = <TrendKeywordPanel keywords={firstPage} onSelect={onSelect} size="desktop" />;
      $[4] = firstPage;
      $[5] = onSelect;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  const t3 = `translateX(-${pageIndex * 100}%)`;
  let t4;
  if ($[7] !== t3) {
    t4 = {
      transform: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const trackStyle = t4;
  const t5 = pageIndex === 0 ? "primary-line" : "sub-line";
  const t6 = pageIndex === 0;
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setPageIndex(0);
    t8 = <SvgChevronleft className="size-14" />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t5 || $[12] !== t6) {
    t9 = <Button theme={t5} dimensions="H40" className="flex-1" aria-pressed={t6} onClick={t7}>{t8}1~10위</Button>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = pageIndex === 1 ? "primary-line" : "sub-line";
  const t11 = pageIndex === 1;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setPageIndex(1);
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SvgChevronright className="size-14" />;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t10 || $[17] !== t11) {
    t14 = <Button theme={t10} dimensions="H40" className="flex-1" aria-pressed={t11} onClick={t12}>11~20위{t13}</Button>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t14 || $[20] !== t9) {
    t15 = <div className="flex gap-4">{t9}{t14}</div>;
    $[19] = t14;
    $[20] = t9;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = pageIndex !== 0;
  let t17;
  if ($[22] !== firstPage || $[23] !== onSelect) {
    t17 = <TrendKeywordPanel keywords={firstPage} onSelect={onSelect} size="desktop" />;
    $[22] = firstPage;
    $[23] = onSelect;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t16 || $[26] !== t17) {
    t18 = <div className="w-full shrink-0" inert={t16}>{t17}</div>;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const t19 = pageIndex !== 1;
  let t20;
  if ($[28] !== onSelect || $[29] !== secondPage) {
    t20 = <TrendKeywordPanel keywords={secondPage} onSelect={onSelect} size="desktop" />;
    $[28] = onSelect;
    $[29] = secondPage;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t19 || $[32] !== t20) {
    t21 = <div className="w-full shrink-0" inert={t19}>{t20}</div>;
    $[31] = t19;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== t18 || $[35] !== t21 || $[36] !== trackStyle) {
    t22 = <div className="mt-12 overflow-hidden"><div className="flex transition-transform duration-300 ease-out motion-reduce:transition-none" style={trackStyle}>{t18}{t21}</div></div>;
    $[34] = t18;
    $[35] = t21;
    $[36] = trackStyle;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t15 || $[39] !== t22) {
    t23 = <>{t15}{t22}</>;
    $[38] = t15;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  return t23;
};